import {ConfigObjectType} from '@wallaby-ui/core';
import {documentContainer} from '@wallaby-ui/document';
import * as React from 'react';
import {useParams} from 'react-router-dom';

import {HospitalizationDocumentLayout} from './HospitalizationDocumentLayout';

interface OwnProps {
  config: ConfigObjectType;
  storageIdPrefix: string;
}

type Props = OwnProps;

export const HospitalizationDocumentLayoutContainer: React.FC<Props> = (props) => {
  const {config, storageIdPrefix} = props;
  const {documentId, hospitalizationId} = useParams();
  const {isLoading, isError, rawDocumentData} = documentContainer.useLoadDocument({
    config,
    documentId,
    encounterId: hospitalizationId,
  });

  return documentId ? (
    <HospitalizationDocumentLayout
      key={documentId}
      isLoading={isLoading}
      isError={isError}
      documentData={rawDocumentData}
      documentVersionId={documentId}
      storageIdPrefix={storageIdPrefix}
    />
  ) : null;
};

HospitalizationDocumentLayoutContainer.displayName = 'HospitalizationDocumentLayoutContainer';
